let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4kTjs")).then(() => parcelRequire('jepjq'));